module.exports = __webpack_public_path__ + "static/media/coste_new.d396bde5.jpg";